(function () {
  'use strict';
  var d = document;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function cartBump() {
    var host = d.getElementById('header-component') || d.body;
    if (!host || !('MutationObserver' in window)) return;
    var read = function () {
      var b = d.querySelector('#header-component .cart-bubble');
      return b ? b.textContent.replace(/\s+/g, '') : '';
    };
    var last = read();
    new MutationObserver(function () {
      var now = read();
      if (now === last) return;
      var had = last;
      last = now;
      if (!now || now === '0' || had === now) return;
      var b = d.querySelector('#header-component .cart-bubble');
      if (!b) return;
      b.classList.remove('tv-bump');
      void b.offsetWidth;
      b.classList.add('tv-bump');
    }).observe(host, { subtree: true, childList: true, characterData: true });
  }

  function reveal() {
    if (!('IntersectionObserver' in window)) return;
    var items = [];
    var sections = d.querySelectorAll('main .shopify-section');
    for (var i = 1; i < sections.length; i++) {
      var s = sections[i];
      if (s.querySelector('.tv-home') || s.querySelector('.product-grid__item')) continue;
      items.push([s, 0]);
    }
    var cards = d.querySelectorAll('.product-grid__item');
    for (var j = 0; j < cards.length; j++) items.push([cards[j], j % 4]);
    if (!items.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('tv-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    var armed = false;
    function arm() {
      if (armed) return;
      armed = true;
      var vh = window.innerHeight;
      items.forEach(function (p) {
        if (p[0].getBoundingClientRect().top > vh * 0.92) {
          p[0].style.setProperty('--tv-i', p[1]);
          p[0].classList.add('tv-pre');
          io.observe(p[0]);
        }
      });
    }
    window.addEventListener('scroll', arm, { passive: true, once: true });
  }

  function init() { cartBump(); reveal(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();

/* Motion layer 2 (kept separate so a failure here can never break the code above) */
(function () {
  'use strict';
  var d = document;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var hasIO = 'IntersectionObserver' in window;
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  function list(s) { return Array.prototype.slice.call(d.querySelectorAll(s)); }

  /* 1. Header shadow + progress line on scroll */
  function scrollFx() {
    var root = d.documentElement;
    var ownBar = d.querySelector('[data-progress]');
    var bar = null;
    if (!ownBar) {
      bar = d.createElement('div');
      bar.className = 'tx-progress';
      bar.setAttribute('aria-hidden', 'true');
      d.body.appendChild(bar);
    }
    var queued = false;
    function update() {
      queued = false;
      var y = window.scrollY || 0;
      root.classList.toggle('tx-scrolled', y > 8);
      if (bar) {
        var max = root.scrollHeight - window.innerHeight;
        bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(y / max, 1) : 0) + ')';
      }
    }
    window.addEventListener('scroll', function () { if (!queued) { queued = true; raf(update); } }, { passive: true });
    update();
  }

  /* 2. Headings: words rise out of a mask (only headings still below the fold) */
  function splitHeadings() {
    if (!hasIO) return;
    var vh = window.innerHeight;
    var targets = list('.tv-sec-head h2, .tv-home .tv-image h2, .tv-why h2, .tvl-sec h2, .tvl-pov h2, .tvl-final h2, .tvl-band h2');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('tx-go'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 });
    targets.forEach(function (h) {
      if (h.children.length || h.getBoundingClientRect().top < vh * 0.9) return;
      var text = h.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return;
      h.setAttribute('aria-label', text);
      h.textContent = '';
      text.split(' ').forEach(function (word, i, all) {
        var w = d.createElement('span');
        w.className = 'tx-w';
        w.setAttribute('aria-hidden', 'true');
        var inner = d.createElement('span');
        inner.className = 'tx-wi';
        inner.style.setProperty('--i', i);
        inner.textContent = word;
        w.appendChild(inner);
        h.appendChild(w);
        if (i < all.length - 1) h.appendChild(d.createTextNode(' '));
      });
      h.classList.add('tx-split');
      io.observe(h);
    });
  }

  /* 3. Count-up for the first number in the trust strip values */
  function countUp() {
    if (!hasIO) return;
    var els = list('.tv-trust__v');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        run(e.target);
      });
    }, { threshold: 0.6 });
    function run(el) {
      var full = el.textContent;
      var m = full.match(/\d[\d,]*/);
      if (!m) return;
      var end = parseInt(m[0].replace(/,/g, ''), 10);
      if (!end || end > 100000) return;
      var before = full.slice(0, m.index), after = full.slice(m.index + m[0].length);
      el.style.minWidth = el.getBoundingClientRect().width + 'px';
      var t0 = null, dur = 900;
      function step(t) {
        if (t0 === null) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = before + Math.round(end * eased) + after;
        if (p < 1) raf(step); else el.textContent = full;
      }
      el.textContent = before + '0' + after;
      raf(step);
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* 4. Gentle parallax on large photos */
  function parallax() {
    var imgs = list('.tv-hero__img, .tv-image__img, .tvl-pov__img');
    if (!imgs.length) return;
    imgs.forEach(function (im) { im.classList.add('tx-par'); });
    var queued = false;
    function update() {
      queued = false;
      var vh = window.innerHeight;
      imgs.forEach(function (im) {
        var host = im.parentElement || im;
        var r = host.getBoundingClientRect();
        if (r.bottom < -50 || r.top > vh + 50) return;
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        im.style.setProperty('--tx-p', Math.max(-1, Math.min(1, p)).toFixed(3));
      });
    }
    window.addEventListener('scroll', function () { if (!queued) { queued = true; raf(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* 5. Magnetic primary buttons (mouse only) */
  function magnetic() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    list('.tv-hero .tv-btn, .tvl-hero .tvl-btn, .tvl-final .tvl-btn').forEach(function (b) {
      b.classList.add('tx-mag');
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - (r.left + r.width / 2)) / r.width;
        var y = (e.clientY - (r.top + r.height / 2)) / r.height;
        b.style.transform = 'translate(' + (x * 10).toFixed(1) + 'px,' + (y * 8).toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* 6. Ring flash when something is added to the cart */
  function addedRing() {
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.tvl-btn, .tv-add, .add-to-cart-button');
      if (!b) return;
      b.classList.remove('tx-added');
      void b.offsetWidth;
      b.classList.add('tx-added');
      setTimeout(function () { b.classList.remove('tx-added'); }, 800);
    });
  }

  function init() {
    try { scrollFx(); splitHeadings(); countUp(); parallax(); magnetic(); addedRing(); } catch (err) { /* never block the page */ }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
